import { ConfigurationItemEditor } from '@client/components/_core/configuration/ConfigurationItemEditor';
import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { Settings2 } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents/general/timeline')({
    staticData: {
        metadata: {
            title: 'Timeline',
        },
        ui: {
            icon: Settings2,
            title: 'Incident settings',
            subtitle: 'Types, causes, impacts, timeline and lodgement form configuration',
        },
    },
    component: IncidentTimeline,
});

function IncidentTimeline() {
    return (
        <PageController route={Route}>
            <ConfigurationItemEditor
                title="Incident timeline items"
                settingToEdit="INCIDENT_TIMELINE_ITEMS"
                description="Rename, add or remove an incident timeline item."
                editor={{ height: '300px' }}
            />
        </PageController>
    );
}
